import { useQuery } from '@apollo/client';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import NBNoticesForm from '@website/components/trips/edit/NBNoticesForm';
import TripFormLayout from '@website/components/trips/edit/TripFormLayout';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { TripDetailsForTripEditFormDocument } from '@website/types/graphqlOperations';
import { useRouter } from 'next/router';

export function NoticesEditTab({ query }) {
  const { tripUrl } = query;
  const baseUrl = `/trips/${query.tripUrl}/edit`;

  const { data, loading, error } = useQuery(
    TripDetailsForTripEditFormDocument,
    {
      variables: {
        urlSlug: tripUrl,
      },
    },
  );

  if (loading) return <LoadingPage />;
  if (error) return <ErrorPage error={error} />;

  const trip = data.tripByURL;

  return (
    <div>
      <TripFormLayout
        title={trip.title}
        baseUrl={baseUrl}
        tab="notices"
        tripUrl={tripUrl}
        host={trip.host}
      >
        <NBNoticesForm trip={data?.tripByURL} />
      </TripFormLayout>
    </div>
  );
}

export default function EditTripTabPage() {
  const { query } = useRouter();
  if (!query) return <LoadingPage />;

  return (
    <RequiresAuth>
      <NoticesEditTab query={query} />
    </RequiresAuth>
  );
}
